import React, { useState, useEffect } from "react";
import { oneOfType, array, bool, shape } from "prop-types";
import { connect } from "react-redux";
import { Link } from "react-router-dom";

import { selectors as loansSelectors } from "reducers/loans";

import Container from "pages/_components/Container";
import GridTable from "pages/_components/GridTable/GridTable";
import * as i18n from "util/i18n";
import CustomText from "pages/_components/CustomText/CustomText";
import FormattedDate from "pages/_components/FormattedDate";
import FormattedAmount from "pages/_components/FormattedAmount";
import Drawer from "pages/_components/Drawer/Drawer";
import FilterTags from "pages/_components//FilterTags";
import I18n from "pages/_components/I18n";
import EmptyScreenAlert from "pages/_components/EmptyScreenAlert/EmptyScreenAlert";
import CustomData from "pages/_components/CustomData/CustomData";
import getCellPlacement from "util/helpers/table";
import LoansFilter from "./LoansFilter";

const ActiveLoans = ({ isDesktop, activeLoans, filteredLoans, filters, isLoading }) => {
    const [openSidebar, setOpenSidebar] = useState(false);
    const [activeLoansToShow, setActiveLoansToShow] = useState([]);

    const columnsActive = isDesktop ? 4 : 2;
    const rows = isDesktop ? 1 : 3;
    const columnsTemplate = isDesktop ? `repeat(3, 1fr) ` : "1fr";
    const hasActiveLoans =
        (filters.loanNumber !== null && filters.loanNumber !== "") || filters.creditedAmount !== null
            ? filteredLoans.length > 0
            : activeLoans.length > 0;

    useEffect(() => {
        const loans =
            (filters.loanNumber !== null && filters.loanNumber !== "") || filters.creditedAmount !== null
                ? filteredLoans
                : activeLoans;
        setActiveLoansToShow(loans);
    }, [activeLoans, filteredLoans]);

    const openSideBarFilters = () => {
        setOpenSidebar(true);
    };

    const contentTable = ({ item }) => {
        const getCellProps = (row, col) => getCellPlacement(row, col, { isDesktop });
        return (
            <>
                <GridTable.Data
                    columnWidth={1}
                    rowWidth={1}
                    className="modalities"
                    alignX="left"
                    alignY="start"
                    flexDirection={isDesktop ? "row" : "column"}
                    {...getCellProps(1, 1)}>
                    <CustomData
                        titleText={item.tipo}
                        titleTextType="STRING"
                        valueText={`N° ${item.nroPrestamo}`}
                        valueTextType="STRING"
                        titleClass="custom-text-loan-type"
                        valueClass="custom-text-loan-number"
                    />
                </GridTable.Data>

                <GridTable.Data
                    columnWidth={1}
                    rowWidth={1}
                    alignX="left"
                    alignY="start"
                    flexDirection={isDesktop ? "row" : "column"}
                    {...getCellProps(1, 2)}>
                    <CustomData
                        titleText={i18n.get("loans.list.tab.activeLoans.card.amount")}
                        titleTextType="STRING"
                        valueText={<FormattedAmount currency="ARS" quantity={item.monto} key={item.number} />}
                        valueTextType="STRING"
                    />
                </GridTable.Data>

                <GridTable.Data
                    columnWidth={1}
                    rowWidth={1}
                    alignX="left"
                    alignY="start"
                    flexDirection={isDesktop ? "row" : "column"}
                    {...getCellProps(1, 3)}>
                    <CustomData
                        titleText={i18n.get("loans.list.tab.activeLoans.card.nextPaymentDate")}
                        titleTextType="STRING"
                        valueText={
                            <CustomText
                                text={
                                    item.fechaProximoPago && (
                                        <FormattedDate date={item.fechaProximoPago} timeZone="UTC" />
                                    )
                                }
                                key={item.nroPrestamo}
                            />
                        }
                        valueTextType="STRING"
                    />
                </GridTable.Data>
                <GridTable.Data
                    columnWidth={1}
                    rowWidth={1}
                    alignX="left"
                    alignY="start"
                    flexDirection={isDesktop ? "row" : "column"}
                    {...getCellProps(1, 4)}>
                    <CustomData
                        titleText={i18n.get("loans.list.tab.activeLoans.card.pendingFees")}
                        titleTextType="STRING"
                        valueText={
                            <CustomText
                                text={`${item.cuotasPendientes} de ${item.cantCuotas} cuotas`}
                                key={item.number}
                            />
                        }
                        valueTextType="STRING"
                    />
                </GridTable.Data>
            </>
        );
    };

    return (
        <div className="container pb-8">
            <FilterTags openSideBarFilters={openSideBarFilters} />
            <Drawer openSidebar={openSidebar} toggleSidebar={setOpenSidebar}>
                <div className="container full-width">
                    <div className="mb-4 f-weight-b">
                        <I18n id="loans.filters.title" component="h2" />
                    </div>
                    <div className="text-left">
                        <LoansFilter loanType="A" closeSidebar={setOpenSidebar} />
                    </div>
                </div>
            </Drawer>
            <Container className="container--layout mb-7 mt-5 loans" showLoader={isLoading}>
                {!hasActiveLoans && <EmptyScreenAlert message="loans.list.tab.activeLoans.noPending" />}
                {activeLoansToShow.map((item) => (
                    <GridTable>
                        <GridTable.Body>
                            <GridTable.Container
                                className="box box-shadow px-6 pt-9 pb-9"
                                key="1551"
                                columns={columnsActive}
                                rows={rows}
                                renderAs={Link}
                                columnsTemplate={columnsTemplate}
                                to={`/loans/detallePrestamo/${item.nroPrestamo}`}>
                                {contentTable({ item })}
                            </GridTable.Container>
                        </GridTable.Body>
                    </GridTable>
                ))}
            </Container>
        </div>
    );
};
ActiveLoans.propTypes = {
    isDesktop: bool.isRequired,
    isLoading: bool,
    activeLoans: oneOfType([array]),
    filteredLoans: oneOfType([array]),
    filters: shape({}),
};

ActiveLoans.defaultProps = {
    isLoading: false,
    activeLoans: [],
    filteredLoans: [],
    filters: shape({}),
};

const mapStateToProps = (state) => ({
    filteredLoans: loansSelectors.getFilteredLoans(state),
    filters: loansSelectors.getFilters(state),
});

export default connect(mapStateToProps)(ActiveLoans);
